import 'rc-time-picker/assets/index.css';

import React, { Component } from 'react';

import moment from 'moment';

import TimePicker from 'rc-time-picker';

class WidgetTimePicker extends Component {
    constructor(props) {
        super(props);

        this.state = {
            format: 'h:mm a',
            now: moment()
        };
    }

    componentWillUpdate(nextProps, nextState) {
        if (this.props.value !== nextProps.value) {
            var newTime = moment(nextProps.value, 'H:mm');
            this.setState({
                value: newTime
            });
        }
    }

    onChange(value) {
        this.props.onChange(value.format('H:mm'));
    }

    render() {
        return (
            <TimePicker
                showSecond={false}
                defaultValue={this.state.now}
                value={this.state.value}
                onChange={this.onChange.bind(this)}
                format={this.state.format}
                disabled={this.props.schema.disable}
                use12Hours
                inputReadOnly
            />
        );
    }
}

export default WidgetTimePicker;



// WEBPACK FOOTER //
// ./src/lib/widget-timePicker.js